module.exports = __webpack_public_path__ + "img/business-deal.2665f7e2.svg";